import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function Loader() {
    return (
        <Box sx={{ display: 'flex', height: '400px', justifyContent: 'center', alignItems: 'center' }} className={'container'}>
            <CircularProgress />
        </Box>
    );
}